export const FIELD_NAME = 'pLTV'
